import React, { ReactNode, useCallback } from 'react';
import classnames from 'classnames';
import Icon from '@vtblife/uikit-icons';

import classes from './chat-side-menu.module.css';
import { ChatAside } from './chat-aside';
import { IS_WEBVIEW_CLIENT } from '../../constants';

export interface ChatSideMenuProps {
    onClose?: () => void;
    className?: string;
    children: ReactNode;
    dataTest?: string;
    banClosing?: boolean;
}

export const ChatSideMenu: React.FC<ChatSideMenuProps> = ({
    onClose = () => undefined,
    className,
    children,
    banClosing,
    dataTest,
}) => {
    const close: (() => void) | undefined = useCallback(() => onClose(), [onClose]);

    return (
        <ChatAside
            className={classnames(classes.modal, classes.defaultWidth, className)}
            onClose={onClose}
            banClosing={banClosing}
            dataTest={dataTest}
        >
            {!IS_WEBVIEW_CLIENT && (
                <div className={classes.close} onClick={close} data-test="asideCloseButton">
                    <Icon name="times" size="s" />
                </div>
            )}
            {children}
        </ChatAside>
    );
};
